import { createContext } from 'react';

import type { IndividualCalendarState } from '@app/providers/CalendarProvider/IndividualCalendarContext.types';

export const IndividualCalendarContext = createContext<IndividualCalendarState>(
  {
    individualCalendarData: [],
    setIndividualCalendarData: () => {},
    branchWorkingHoursForPeriod: [],
    setBranchWorkingHoursForPeriod: () => {},
    lastStoredIndividualCalendarData: [],
    setLastStoredIndividualCalendarData: () => {},
  }
);
